import { Controller } from "@hotwired/stimulus"
import Carousel from "flowbite/lib/esm/components/carousel"

let sequence = 0

// Flowbite carousel (static — no auto-cycling):
//
//   <div data-controller="carousel">
//     <div data-carousel-target="item">…</div>
//     <button data-carousel-target="indicator"></button>
//     <button data-action="carousel#prev">…</button>
//   </div>
// One instance per carousel element, keyed by its id (override: true); a
// generated id only covers elements rendered without one.
export default class extends Controller {
  static targets = ["item", "indicator"]

  connect() {
    const items = this.itemTargets.map((el, position) => ({ position, el }))
    const indicators = this.indicatorTargets.map((el, position) => ({
      position,
      el,
    }))

    this.carousel = new Carousel(
      this.element,
      items,
      { indicators: { items: indicators } },
      { id: this.element.id || `carousel-${++sequence}`, override: true },
    )
  }

  disconnect() {
    this.carousel?.destroyAndRemoveInstance()
    this.carousel = null
  }

  prev() {
    this.carousel?.prev()
  }

  next() {
    this.carousel?.next()
  }
}
